function capitalizeFirstLetter(string) {
  if (!string) return;
  let strToLowerCase = string.toLowerCase()
  return strToLowerCase.charAt(0).toUpperCase() + strToLowerCase.slice(1);
}

export default capitalizeFirstLetter